module.exports = __webpack_public_path__ + "static/img/clock.ac280bee.png";